var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 24,
  height: 24,
  rx: 12,
  fill: "url(#paint0_linear_1270_3400)"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1270_3400)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6026 7.39178C16.2491 6.04405 14.449 5.30147 12.531 5.30078C8.57882 5.30078 5.36232 8.49917 5.36094 12.4306C5.36026 13.6874 5.69064 14.9141 6.31806 15.9951L5.30078 19.6903L9.10173 18.6988C10.1489 19.267 11.3281 19.5662 12.5279 19.5665H12.531C16.4825 19.5665 19.6994 16.3678 19.7008 12.4364C19.7015 10.531 18.9565 8.73986 17.6026 7.39213V7.39178ZM12.531 18.3624H12.5286C11.4594 18.3621 10.4105 18.0762 9.49538 17.5364L9.27775 17.4078L7.02214 17.9962L7.62412 15.8091L7.48247 15.5848C6.886 14.6413 6.57074 13.5506 6.57143 12.4309C6.57281 9.16347 9.24612 6.50492 12.5335 6.50492C14.1252 6.5056 15.6214 7.12272 16.7466 8.2431C17.8718 9.36313 18.491 10.8524 18.4903 12.4357C18.4889 15.7035 15.8156 18.3621 12.531 18.3621V18.3624ZM15.7998 13.924C15.6207 13.8347 14.7399 13.4039 14.5755 13.3445C14.4112 13.2849 14.2919 13.2552 14.1726 13.4337C14.0533 13.6122 13.7099 14.0135 13.6054 14.1322C13.5009 14.2511 13.3963 14.2659 13.2172 14.1766C13.0381 14.0874 12.4609 13.8993 11.7764 13.2925C11.2439 12.82 10.8843 12.2367 10.7798 12.0582C10.6753 11.8798 10.7688 11.7834 10.8581 11.6948C10.9386 11.6148 11.0373 11.4866 11.127 11.3827C11.2167 11.2787 11.2463 11.2042 11.3061 11.0856C11.3659 10.9666 11.336 10.8627 11.2913 10.7734C11.2466 10.6842 10.8884 9.80723 10.7389 9.45065C10.5934 9.10329 10.4456 9.15047 10.3359 9.14466C10.2314 9.13953 10.1121 9.13851 9.9925 9.13851C9.87286 9.13851 9.67894 9.18295 9.51462 9.36142C9.3503 9.53987 8.88755 9.971 8.88755 10.8476C8.88755 11.7242 9.52942 12.5718 9.61914 12.6908C9.70886 12.8097 10.8825 14.6091 12.6795 15.3811C13.1069 15.5647 13.4407 15.6744 13.7009 15.7565C14.13 15.8922 14.5205 15.8731 14.8293 15.8273C15.1734 15.776 15.8892 15.3961 16.0384 14.98C16.1876 14.564 16.1876 14.207 16.1429 14.1328C16.0982 14.0586 15.9786 14.0139 15.7995 13.9246L15.7998 13.924Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1270_3400",
  x1: 12.5,
  y1: 0.5,
  x2: 12.5,
  y2: 24.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61FD7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#25CF43"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1270_3400"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14.4,
  height: 14.4,
  fill: "white",
  transform: "translate(5.30078 5.30078)"
})));

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.233de67ffacd24a8989bf1ac468f66f3.svg";
export { ForwardRef as ReactComponent };